<span style="padding: 15px;"><strong>Reports</strong> | Collections/Payments Received</span>
<mat-tab-group style="height:  calc(100% - 30px);">
    <mat-tab label="Promise To Pays">
        <app-ptp-date-based></app-ptp-date-based>
    </mat-tab>
    <mat-tab label="Arrangement">
        <app-arrangement-date-based></app-arrangement-date-based>
    </mat-tab>
</mat-tab-group>